<template>
  <div class="points-order-container">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>积分商品订单管理</span>
        </div>
      </template>
      
      <!-- 搜索区域 -->
      
      <!-- 订单列表 -->
      <div class="order-list">
        <el-table :data="orderList" stripe style="width: 100%">
          <el-table-column prop="id" label="订单号" width="200" />
          <el-table-column prop="uname" label="用户" width="150" />
          <el-table-column prop="phone" label="手机号" width="150" />
          <el-table-column prop="name" label="商品名称" />
          <el-table-column prop="cost" label="积分" width="120" />
          <el-table-column prop="time" label="申请时间" width="200">
            <template #default="scope">
              {{ maketime(scope.row.time) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template #default="scope">
              <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <div v-if="scope.row.status === '审核中'">
                <el-button type="primary" size="small" @click="approveOrder(scope.row)" style="margin-right: 8px">通过</el-button>
                <el-button type="danger" size="small" @click="rejectOrder(scope.row)">驳回</el-button>
              </div>
              <div v-else>
                <el-button type="info" size="small" disabled>{{ getStatusText(scope.row.status) }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PointsOrder',
  data() {
    return {
      searchForm: {
        name: '',
        uname: '',
        status: ''
      },
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.getOrderList()
  },
  methods: {
    // 获取订单列表
    async getOrderList() {
      try {
        // 模拟API请求
        // const response = await this.$api.get('/points/order/list', {
        //   page: this.currentPage,
        //   pageSize: this.pageSize,
        //   ...this.searchForm
        // })

        const ret = await this.$api.bgyx.bgyxpage('goodsorder', {current:this.currentPage,pageSize:this.pageSize});
        console.log(9999,ret)
        // 模拟数据
        // const mockData = {
        //   total: 3,
        //   list: [
        //     {
        //       id: 1,
        //       orderNo: 'PO20240306001',
        //       userName: '张三',
        //       userPhone: '13800138000',
        //       productName: '车载香薰',
        //       points: 299,
        //       createTime: '2024-03-06 10:00:00',
        //       status: 'pending'
        //     },
        //     {
        //       id: 2,
        //       orderNo: 'PO20240306002',
        //       userName: '李四',
        //       userPhone: '13900139000',
        //       productName: '玻璃水',
        //       points: 199,
        //       createTime: '2024-03-06 09:30:00',
        //       status: 'approved'
        //     },
        //     {
        //       id: 3,
        //       orderNo: 'PO20240306003',
        //       userName: '王五',
        //       userPhone: '13700137000',
        //       productName: '洗车券',
        //       points: 399,
        //       createTime: '2024-03-06 08:00:00',
        //       status: 'rejected'
        //     }
        //   ]
        // }
        
        this.orderList = ret.data.data
        this.total = ret.data.total
        this.currentPage = ret.data.page.current
        this.pageSize = ret.data.page.pageSize
      } catch (error) {
        this.$message.error('获取订单列表失败')
      }
    },
    
    // 搜索
    search() {
      this.currentPage = 1
      this.getOrderList()
    },
    
    // 重置
    reset() {
      this.searchForm = {
        orderNo: '',
        userName: '',
        status: ''
      }
      this.currentPage = 1
      this.getOrderList()
    },
    
    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.getOrderList()
    },
    
    handleCurrentChange(current) {
      this.currentPage = current
      this.getOrderList()
    },
    
    // 获取状态文本
    getStatusText(status) {
      return status
    },
    maketime(t) {
      return moment(t).format('YYYY-MM-DD HH:mm:ss')
    },
    // 获取状态类型
    getStatusType(status) {
      const typeMap = {
        '审核中': 'warning',
        '已通过': 'success',
        '已驳回': 'danger'
      }
      return typeMap[status] || ''
    },
    
    // 通过订单
    async approveOrder(order) {
      try {
        // 模拟API请求
        await this.$api.bgyx.orpost('bgyx/bgyx/putdata/goodsorder', { id: order.id,status:'已通过' })
        
        this.$message.success('订单已通过')
        this.getOrderList()
      } catch (error) {
        this.$message.error('操作失败')
      }
    },
    
    // 驳回订单
    async rejectOrder(order) {
      try {
        // 模拟API请求
        await this.$api.bgyx.orpost('bgyx/bgyx/reject/goodsorder', { id: order.id })
        
        this.$message.success('订单已驳回')
        this.getOrderList()
      } catch (error) {
        console.log(error)
        this.$message.error('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.points-order-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.search-section {
  margin-bottom: 20px;
}

.search-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
}

.order-list {
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>